import { IRocketTokens } from '@eventr/common'
import { effect, signal } from '@preact/signals-react'
import shareExtensionListener from '../../feat/ios-share-extension/shareExtensionListener'

export const liveToken = signal<IRocketTokens | undefined>(undefined)

export const scrollStyle = signal<'auto' | 'stationary' | 'none'>('auto')

export const groupChatName = signal<string>('')

export const chatFallBackName = signal<string>('')

export const sentMessage = signal<boolean>(false)

effect(shareExtensionListener)
